import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {LanguageContext} from '../../../../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../../../../layouts/theme/designSystem';
import {Skill} from '../../../../../../types/shared-recruiting-types';

interface Props {
  applicantSkills?: Skill[];
}

export const ApplicantSkills = ({applicantSkills}: Props) => {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  if (!applicantSkills || applicantSkills.length === 0) {
    return;
  }

  const createSkillsCards = () => {
    if (!applicantSkills) {
      return null;
    }

    return applicantSkills.map((skill) => {
      return (
        <Box
          display={'flex'}
          key={skill.resourceId}
          bgcolor={orangeColors[5]}
          mr={2}
          mb={2}
          p={'4px 16px'}
        >
          <Grid item mr={1}>
            <Typography variant='body1'>{skill.standardSkill.name[currentLanguage]}</Typography>
          </Grid>
        </Box>
      );
    });
  };

  return (
    <Grid container direction='column'>
      <Grid item mb={1}>
        <Typography variant='h3'>{t('companyApplicants.applicantsCard.cardDetails.skills')}</Typography>
      </Grid>
      {(applicantSkills?.length || 0) > 0 ? (
        <Grid container direction='row'>
          {createSkillsCards()}
        </Grid>
      ) : (
        <Typography variant='body1' fontStyle={'italic'}>
          {t('companyApplicants.applicantsCard.cardDetails.emptyState.noSkills')}
        </Typography>
      )}
    </Grid>
  );
};
